export const corpBaseUrl = process.env.REACT_APP_API_URL;